export default __webpack_public_path__ + "static/media/Animesh.b88e6f20.jpg";